import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const query = graphql`
  query Projects {
    allAirtable(
      filter: { table: { eq: "Projects" }, data: { featured: { eq: true } } }
    ) {
      nodes {
        data {
          title
          image {
            localFiles {
              childImageSharp {
                gatsbyImageData(placeholder: TRACED_SVG, layout: FULL_WIDTH)
              }
            }
          }
          description
          link
        }
      }
    }
  }
`;

const Projects = () => {
  const {
    allAirtable: { nodes: projects },
  } = useStaticQuery(query);
  return (
    <section className={`section projects`}>
      <div className="section-title">
        <h2>latest works</h2>
        <div className="underline"></div>
        <p className="projects-text">
          A small gallery of recent projects chosen by me. I've done them all
          together with amazing people around the globe. It's only a drop in the
          ocean compared to the entire list. Interested to see some more? Visit
          my work page.
        </p>
      </div>

      <div className={`section-center projects-center`}>
        {projects.map((project, index) => {
          const { title, description, link, image } = project.data;

          return (
            <a key={index} href={link}>
              <article className="project">
                <GatsbyImage
                  image={getImage(image.localFiles[0])}
                  alt={title}
                  className="project-img"
                />
                <div className="project-info">
                  <h4>{title}</h4>
                  <p>{description}</p>
                </div>
              </article>
            </a>
          );
        })}
      </div>
    </section>
  );
};

export default Projects;
